!(function (t, e) {
  "object" == typeof exports && "object" == typeof module
    ? (module.exports = e())
    : "function" == typeof define && define.amd
    ? define([], e)
    : "object" == typeof exports
    ? (exports.Tabs = e())
    : (t.Tabs = e());
})(window, function () {
  return (function (t) {
    var e = {};
    function i(n) {
      if (e[n]) return e[n].exports;
      var o = (e[n] = { i: n, l: !1, exports: {} });
      return t[n].call(o.exports, o, o.exports, i), (o.l = !0), o.exports;
    }
    return (
      (i.m = t),
      (i.c = e),
      (i.d = function (t, e, n) {
        i.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: n });
      }),
      (i.r = function (t) {
        "undefined" != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }),
          Object.defineProperty(t, "__esModule", { value: !0 });
      }),
      (i.t = function (t, e) {
        if ((1 & e && (t = i(t)), 8 & e)) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var n = Object.create(null);
        if (
          (i.r(n),
          Object.defineProperty(n, "default", { enumerable: !0, value: t }),
          2 & e && "string" != typeof t)
        )
          for (var o in t)
            i.d(
              n,
              o,
              function (e) {
                return t[e];
              }.bind(null, o)
            );
        return n;
      }),
      (i.n = function (t) {
        var e =
          t && t.__esModule
            ? function () {
                return t.default;
              }
            : function () {
                return t;
              };
        return i.d(e, "a", e), e;
      }),
      (i.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }),
      (i.p = "/"),
      i((i.s = 10))
    );
  })([
    function (t, e) {
      t.exports = require("jquery");
    },
    function (t, e, i) {
      "use strict";
      i.r(e),
        i.d(e, "get_scroll_left", function () {
          return l;
        }),
        i.d(e, "set_scroll_left", function () {
          return s;
        }),
        i.d(e, "detect_is_reverse_scroll", function () {
          return r;
        });
      var n = i(0),
        o = i.n(n),
        r = function () {
          if (window.scrollType) return window.scrollType;
          var t = o()(
              '<div dir="rtl" style="width: 1px; height: 1px; position: fixed; top: 0px; left: 0px; overflow: hidden"><div style="width: 2px"><span style="display: inline-block; width: 1px"></span><span style="display: inline-block; width: 1px"></span></div></div>'
            ).appendTo("body")[0],
            e = "reverse";
          return (
            t.scrollLeft > 0
              ? (e = "default")
              : ((t.scrollLeft = 1), 0 === t.scrollLeft && (e = "negative")),
            o()(t).remove(),
            (window.scrollType = e),
            e
          );
        },
        l = function (t) {
          var e = t.scrollLeft(),
            i = r();
          return window.__isRtl
            ? "negative" === i
              ? e + t.get(0).scrollWidth - t.get(0).clientWidth
              : "reverse" === i
              ? t.get(0).scrollWidth - e - t.get(0).clientWidth
              : e
            : e;
        },
        s = function (t, e, i) {
          void 0 === i && (i = !1);
          var n = r();
          if (!window.__isRtl) {
            if (i) return e;
            t.scrollLeft(e);
          }
          if (
            ("negative" === n &&
              (e = e + t.get(0).clientWidth - t.get(0).scrollWidth),
            "reverse" === n &&
              (e = t.get(0).scrollWidth - t.get(0).clientWidth - e),
            i)
          )
            return e;
          t.scrollLeft(e);
        };
    },
    function (t, e) {
      function i(t, e, i) {
        var n, o, r, l, s;
        function c() {
          var a = Date.now() - l;
          a < e && a >= 0
            ? (n = setTimeout(c, e - a))
            : ((n = null), i || ((s = t.apply(r, o)), (r = o = null)));
        }
        null == e && (e = 100);
        var a = function () {
          (r = this), (o = arguments), (l = Date.now());
          var a = i && !n;
          return (
            n || (n = setTimeout(c, e)),
            a && ((s = t.apply(r, o)), (r = o = null)),
            s
          );
        };
        return (
          (a.clear = function () {
            n && (clearTimeout(n), (n = null));
          }),
          (a.flush = function () {
            n &&
              ((s = t.apply(r, o)),
              (r = o = null),
              clearTimeout(n),
              (n = null));
          }),
          a
        );
      }
      (i.debounce = i), (t.exports = i);
    },
    function (t, e, i) {
      "use strict";
      i.r(e);
      var n = i(0),
        o = i.n(n),
        r = i(2),
        l = (i(4), i(1)),
        s = "change",
        c = "expandMoreBtnClick",
        a = "destroy",
        d = (function () {
          function t(t) {
            (this.config = {
              el: "",
              infinity: !0,
              index: 0,
              showMoreVert: !1,
            }),
              (this.$el = o()()),
              (this.$showMoreVert = o()()),
              (this.$eventEl = o()("<div />")),
              (this.lastIndex = -1),
              (this.randomString = "tabs-" + Math.ceil(1e6 * Math.random())),
              (this.isRtl = "rtl" === document.dir),
              (this.D = null),
              (window.__isRtl = this.isRtl),
              (this.config = o.a.extend({}, this.config, t)),
              (this.$el = o()(this.config.el)),
              this.$el.addClass(this.randomString),
              this.init();
          }
          return (
            (t.prototype.init = function () {
              this.DOM_init(),
                this.event_handle(),
                this.overflow_handle(),
                this.go(this.config.index, !0);
            }),
            (t.prototype.update = function () {
              this.on_resize();
            }),
            (t.prototype.go = function (t, e) {
              void 0 === e && (e = !1);
              var i = this.$el.find("ul li").eq(t);
              if (0 === i.length) return this;
              var n = i.offset().left,
                o = i.position().left,
                r = i.parent().offset().left,
                c = Object(l.get_scroll_left)(i.parent()),
                a = i.parent().outerWidth();
              if (
                (i.hasClass("current") ||
                  this.$eventEl.trigger(s, [t, this.lastIndex]),
                i.addClass("current").siblings().removeClass("current"),
                this.$el.hasClass("tabs-overflow") &&
                  (o + i.outerWidth() > a && (e = !0), o <= 58 && (e = !0)),
                e)
              ) {
                var d = 0;
                this.isRtl,
                  (d = n - r + c),
                  (d -= window.innerWidth < 768 ? 0 : 58),
                  this.isRtl
                    ? Object(l.set_scroll_left)(i.parent(), d)
                    : i.parent().scrollLeft(0 === t ? 0 : d),
                  this.overflow_handle();
              }
              return this.indicator_animate(t), this.on_scroll(), this;
            }),
            (t.prototype.next = function () {
              var t = this.$el.find("li.current").next();
              return (
                t.data("index")
                  ? this.go(t.data("index"))
                  : this.config.infinity && this.go(0),
                this
              );
            }),
            (t.prototype.prev = function () {
              var t = this.$el.find("li.current").prev("li");
              return (
                t.length > 0
                  ? this.go(t.data("index"))
                  : this.config.infinity &&
                    this.go(this.$el.find("ul li").length - 1),
                this
              );
            }),
            (t.prototype.destroy = function () {
              this.$eventEl.trigger(a),
                o()(window).off("resize." + this.randomString),
                (this.$el = o()()),
                this.$eventEl.remove();
            }),
            (t.prototype.on = function (t, e) {
              return this.$eventEl.on(t, e), this;
            }),
            (t.prototype.one = function (t, e) {
              return this.$eventEl.one(t, e), this;
            }),
            (t.prototype.off = function (t) {
              return this.$eventEl.off(t), this;
            }),
            (t.prototype.overflow_handle = function () {
              var t = this.$el.find("ul").eq(0),
                e = t.get(0).scrollWidth;
              t.get(0).clientWidth < e - 1
                ? this.$el.addClass("tabs-overflow")
                : this.$el.removeClass("tabs-overflow");
            }),
            (t.prototype.indicator_animate = function (t, e) {
              void 0 === e && (e = !0),
                (t =
                  t || 0 === t
                    ? t
                    : this.$el.find("li.current").eq(0).data("index"));
              var i = 300,
                n = 420;
              e || ((i = 0), (n = 0));
              var o = this.$el.find("ul li").eq(t),
                r = this.$el.find("ul").eq(0),
                s = this.$el.find(".indicator"),
                c = this.lastIndex - t > 0;
              this.lastIndex = t;
              var a = r.outerWidth(),
                d = Object(l.get_scroll_left)(r),
                f = o.outerWidth(),
                u = o.position().left + d,
                h = a - u - f;
              if (this.isRtl) {
                var p = r.get(0).scrollWidth - d - a,
                  v = a - o.position().left - f + p,
                  g = parseInt(o.css("margin-left"));
                (u = o.position().left - p + g), (h = v - g), (c = !c);
              }
              if (
                ((u += 18),
                (h += 18),
                "my-MM" === document.documentElement.lang && (h += 2),
                a - u - h < 36)
              ) {
                var _ = (36 - (a - u - h)) / 2;
                (u -= _), (h -= _);
              }
              s.animate({ left: u }, { queue: !1, duration: c ? i : n }),
                s.animate({ right: h }, { queue: !1, duration: c ? n : i });
            }),
            (t.prototype.on_scroll = function () {
              var t = this.$el.find("ul"),
                e = Object(l.get_scroll_left)(t),
                i = t.outerWidth();
              this.isRtl
                ? e <= 1
                  ? this.$el.addClass("scrolled-right")
                  : this.$el.removeClass("scrolled-right")
                : Math.ceil(e + i) >= t.get(0).scrollWidth
                ? this.$el.addClass("scrolled-right")
                : this.$el.removeClass("scrolled-right"),
                this.isRtl
                  ? Math.ceil(e + i) >= t.get(0).scrollWidth
                    ? this.$el.addClass("scrolled-left")
                    : this.$el.removeClass("scrolled-left")
                  : e < 1
                  ? this.$el.addClass("scrolled-left")
                  : this.$el.removeClass("scrolled-left");
            }),
            (t.prototype.event_handle = function () {
              var t = this;
              this.$el.find("ul li").on("click", function (e) {
                return t.go(+e.currentTarget.dataset.index);
              }),
                this.$el
                  .find("ul")
                  .on(
                    "scroll",
                    Object(r.debounce)(this.on_scroll.bind(this), 200)
                  ),
                this.$el.find(".overflow-arrow").on("click", function (e) {
                  return t.on_overflow_arrow_click(
                    e.currentTarget.classList.contains("left")
                  );
                }),
                this.$el.find(".tabs-modal-btn").on("click", function () {
                  var e = [];
                  t.$el.find("ul li").map(function (t, i) {
                    e.push({
                      current: i.classList.contains("current"),
                      html: i.innerHTML,
                      index: t,
                    });
                  }),
                    t.$eventEl.trigger(c, [e]);
                }),
                o()(window).on(
                  "resize." + this.randomString,
                  Object(r.debounce)(this.on_resize.bind(this), 200)
                );
            }),
            (t.prototype.on_resize = function () {
              this.indicator_animate(void 0, !1),
                this.overflow_handle(),
                this.on_scroll();
            }),
            (t.prototype.on_overflow_arrow_click = function (t) {
              var e = this,
                i = Object(l.get_scroll_left)(this.$el.find("ul")),
                n = t ? i - 200 : i + 200;
              n < 100 && (n = 0),
                this.isRtl && (n = t ? i + 200 : i - 200),
                this.$el
                  .find("ul")
                  .animate(
                    {
                      scrollLeft: Object(l.set_scroll_left)(
                        this.$el.find("ul"),
                        n,
                        !0
                      ),
                    },
                    120,
                    function () {
                      return e.indicator_animate(void 0, !1);
                    }
                  );
            }),
            (t.prototype.DOM_init = function () {
              this.$el.find("ul").append('<div class="indicator"></div>'),
                this.$el.find("ul li").map(function (t, e) {
                  return (e.dataset.index = t.toString());
                }),
                this.$el.append(
                  '<button class="btn btn-icon overflow-arrow left"><span class="material-icons-round">navigate_before</span></button>'
                ),
                this.$el.append(
                  '<button class="btn btn-icon overflow-arrow right"><span class="material-icons-round">navigate_next</span></button>'
                );
            }),
            t
          );
        })();
      e.default = d;
    },
    function (t, e, i) {},
    ,
    ,
    ,
    ,
    ,
    function (t, e, i) {
      t.exports = i(3);
    },
  ]);
});
